module.exports = __webpack_public_path__ + "img/huobi.d037adef.svg";